import ComplaintsList from "../../components/complaints/ComplaintsList"

export const ComplaintsUsersPage = () => {

    return (
        <ComplaintsList></ComplaintsList>
    )
}